import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPages = () => {
    const pages = [];
    pages.push(1);
    if (currentPage > 3) pages.push("...");
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++
    ) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push("...");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  const pages = getPages();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 rounded-md bg-[#2d2e32] text-white disabled:opacity-40 border border-[#444447]"
      >
        <FaChevronLeft size={10} />
      </button>

      {pages.map((page, index) =>
        page === "..." ? (
          <span key={index} className="px-1 text-gray-400 text-xs">
            ...
          </span>
        ) : (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={`w-7 h-7 rounded-md text-xs border ${
              page === currentPage
                ? "bg-[#2d2e32] text-white font-semibold border-[#666]"
                : "text-gray-300 hover:text-white border-[#444447] bg-[#2d2e32]"
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 rounded-md bg-[#2d2e32] text-white disabled:opacity-40 border border-[#444447]"
      >
        <FaChevronRight size={10} />
      </button>
    </div>
  );
};

export default Pagination;